module.exports = __webpack_public_path__ + "img/video-default.1253c69c.jpg";